import ChartBoxInner from './chartBoxInner';
import LoaderComponent from '@components/atom/layout/loader';
import FadeLoader from 'react-spinners/FadeLoader';

const ChartBox = ({ freeRankingData = null, paidRankingData = null, grossRankingData = null, isLoading }) => {
  return (
    <>
      {isLoading ? (
        <LoaderComponent height={'250px'}>
          <FadeLoader />
        </LoaderComponent>
      ) : (
        <div className="chart-ranking-wrap">
          {freeRankingData && <ChartBoxInner type={'free'} title={'Free'} data={freeRankingData} />}
          {paidRankingData && <ChartBoxInner type={'paid'} title={'Paid'} data={paidRankingData} />}
          {grossRankingData && <ChartBoxInner type={'grossing'} title={'Grossing'} data={grossRankingData} />}
        </div>
      )}
    </>
  );
};

export default ChartBox;
